import * as _ from "lodash";
import { BaseModifyDashboardWidgetView, BaseModifyDashboardWidgetViewOptions } from "../_BaseModifyWidgetView";
import { Utils } from "../../../../../common/utils";

export class ModifyIframeWidgetView extends BaseModifyDashboardWidgetView {

    protected template = _.template(require("templates/modals/dashboard/modify_widgets/iframe/iframe.html"));

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(_.extend({
            className: 'modify-iframe-widget-view',
            events: {
                'change .tab select': 'handleTabChange'
            }
        }, options));

        // Create default widget if none exists (for new widgets)
        if (!this.options.widget) {
            this.options.widget = new this.options.dashboardWidgetCollection.model({
                dashboard_id: this.options.dashboardId,
                dashboard_category_id: this.options.categoryId,
                dashboard_widget_type_id: 21, // iframe widget type
                type: 'iframe',
                params: [
                    { key: 'IFRAME_URL', value: '' },
                    { key: 'CHART_SIZE', value: '6' }
                ]
            });
        }
    }

    render(): this {
        this.$el.html(this.template({
            dashboardCategoryCollection: this.options.dashboardCategoryCollection,
            dashboardTabCollection: this.options.dashboardTabCollection,
            widget: this.options.widget,
            report: this.options.report,
            categoryId: this.options.widget.get('dashboard_category_id') ? 
                this.options.widget.get('dashboard_category_id') : this.options.categoryId,
            tabId: this.options.tabId
        }));
        
        // Initialize select2 for dropdowns
        this.$('select').select2(Utils.Select2.defaultOptions);
        
        return this;
    }

    show(): void {
        // Initialize tab select
        this.$('.tab select').select2(Utils.Select2.defaultOptions);
        // Initialize category select with tagging support for new categories
        this.initializeCategorySelect('.category select');
    }

    handleTabChange(e: JQuery.Event) {
        var $select = this.$('.tab select');
        var rawValue = $select.val();
        var tabId = rawValue === '' || rawValue === null || rawValue === undefined ? null : Number(rawValue);
        this.options.tabId = tabId;
        this.reloadCategoriesForTab(tabId);
    }

    private validateIframeUrl(url: string): boolean {
        if (!url || url.trim() === '') {
            return true; // Empty URL is allowed
        }

        try {
            const parsedUrl = new URL(url.trim());
            
            // Allowed domains
            const allowedDomains = [
                'chatiot.staging.attuneiot.dev',
                'chatiot.attuneiot.cloud',
                'maps-stage.senseware.co',
                'maps.senseware.co',
                'lobbyview-stage.senseware.co',
                'lobbyview.senseware.co'
            ];
            
            // Check for valid HTTP/HTTPS protocol first
            if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
                this.showError('Invalid URL', 'Please enter a valid URL (must include http:// or https://)');
                return false;
            }
            
            // Check if the domain is allowed
            if (!allowedDomains.includes(parsedUrl.hostname)) {
                this.showError('Invalid Domain', 'URL must be from a public Storyboard.');
                return false;
            }
            
            return true;
        } catch (e) {
            this.showError('Invalid URL', 'Please enter a valid URL (must include http:// or https://)');
            return false;
        }
    }

    private showError(title: string, message: string): void {
        (<any>$).notify({
            title: title,
            message: message,
            icon: 'fa fa-exclamation-circle',
        }, {
            animate: {
                enter: 'animated fadeInUp',
            },
            type: "warning-alt",
            placement: { from: "bottom", align: "center" }
        });
    }

    preSave(): boolean {
        // Get the URL value from the input
        const iframeUrl = this.$('.iframe-url input').val() as string;
        
        // Get the size value from the select
        const iframeSize = this.$('.iframe-size select').val() as string;

        // Validate URL
        if (!this.validateIframeUrl(iframeUrl)) {
            return false;
        }

        // Save the parameters
        this.options.widget.setParamValue('IFRAME_URL', iframeUrl.trim());
        this.options.widget.setParamValue('CHART_SIZE', iframeSize);
        
        return true;
    }

    ensureCollectionLoaded(): JQueryPromise<any> {
        // Iframe widgets don't need to load any collections
        // Return a resolved promise
        return $.Deferred().resolve().promise();
    }

    getChannelDifference(): [any[], any, any[]] {
        // Iframe widgets don't have channels, so return empty arrays
        return [[], {}, []];
    }

    postSave(): boolean {
        // Iframe widgets don't need post-save operations
        return false;
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/iframe/ModifyIframeWidgetView.ts